"use client";

import { useCallback, useEffect } from "react";
import { BaseModal } from "@/components/ui/modal";
import { clearPendingPlanIntent } from "@/features/billing/lib/pendingIntent";
import { useAuthModal } from "../hooks/useAuthModal";
import { useAuthForm } from "../hooks/useAuthForm";
import { AuthModalContent } from "./AuthModalContent";

export function AuthModal() {
  const { isOpen, close } = useAuthModal();
  // A successful sign-in closes through `close` (useAuthForm) and keeps a
  // pending "Get Pro" so it can finish; the user dismissing the modal (X,
  // Escape, backdrop) drops it — else a later, unrelated sign-in in this tab
  // would jump straight to checkout.
  const dismiss = useCallback(() => {
    clearPendingPlanIntent();
    close();
  }, [close]);
  const form = useAuthForm(close);

  useEffect(() => {
    if (isOpen) {
      form.reset();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  return (
    <BaseModal isOpen={isOpen} onClose={dismiss}>
      <AuthModalContent
        mode={form.mode}
        email={form.email}
        password={form.password}
        confirmPassword={form.confirmPassword}
        error={form.error}
        message={form.message}
        loading={form.loading}
        onEmailChange={form.setEmail}
        onPasswordChange={form.setPassword}
        onConfirmPasswordChange={form.setConfirmPassword}
        onEmailSubmit={form.handleEmailSubmit}
        onGoogleAuth={form.handleGoogleAuth}
        onSwitchMode={form.switchMode}
        onClose={dismiss}
      />
    </BaseModal>
  );
}
